import { __decorate } from "tslib";
import { Component, Vue, Emit, Watch } from 'vue-property-decorator';
import { dashboardConfig, fetchWeather } from '@blade-sxp/screen/api/index';
import Clock from '@blade/common/components/clock/index.vue';
import SnapShot from '@blade/common/components/screen-head/snapshot.vue';
import moment from 'moment';
import { SENSECODE } from '@blade/common/constants/code';
import store from '@blade-sxp/screen/store/index';
import { LoginModule } from '@blade/common/store/login';
import ImmersionMode from '@blade-sxp/screen/components/immersion-mode/index.vue';
const MAP_ITEMS = [
    {
        name: 'CAM',
        path: '/screen/crowdInsightCam',
        code: SENSECODE.CROWD_CAM,
        cardId: SENSECODE.CROWD_CAM,
    },
    {
        name: 'CL',
        path: '/screen/crowdInsightCl',
        code: SENSECODE.CROWD_CL,
        cardId: SENSECODE.CROWD_CL,
    },
    {
        name: 'VA',
        path: '/screen/crowdInsightVa',
        code: SENSECODE.CROWD_VA,
        cardId: SENSECODE.CROWD_VA,
        snapShot: true,
    },
    {
        name: 'QUEUE',
        path: '/screen/queueInsight',
        code: SENSECODE.QUEUE_INSIGHT,
        cardId: SENSECODE.QUEUE_INSIGHT,
    },
    {
        name: 'ALERT',
        path: '/screen/alertMap',
        code: SENSECODE.ALERT_MAP,
        cardId: SENSECODE.ALERT_MAP,
    },
    {
        name: 'UV',
        path: '/screen/crowdInsightUv',
        code: SENSECODE.CROWD_UV,
        cardId: SENSECODE.CROWD_UV,
    },
    {
        name: 'PI',
        path: '/screen/parkingInsight',
        code: SENSECODE.PARKING_INSIGHT,
        cardId: SENSECODE.PARKING_INSIGHT,
    },
];
let default_1 = 
/**
 * screen-head
 * 大屏顶部栏 组件引入注解
 * 引入方式：<screen-head @snapDateChange="snapDateChange" />
 *
 * 支持的事件如下：
 * snapDateChange 快照时间选择的事件
 */
class default_1 extends Vue {
    defaultLogoUrl = '';
    defaultLogoName = '';
    mapItems = [];
    permissions = [];
    reloadTimer = 0;
    snapTime = '';
    timeCount = 0;
    refreshTime = ''; // 大屏刷新时间
    celsius = 0; // 摄氏度
    weather = ''; // 温度
    immersionButtonStatus = 0; // 0 默认；1 hover；2 clicked
    snapDateChange(time) {
        this.snapTime = time;
        return time;
    }
    get freezeDay() {
        return this.snapTime?.split(' ')[0];
    }
    get mapType() {
        return store.mapData.mapType;
    }
    get freezeTime() {
        return this.snapTime?.split(' ')[1];
    }
    get path() {
        return this.$route.path;
    }
    get snapShot() {
        const currItem = MAP_ITEMS.find((item) => item.path === this.path);
        return currItem?.snapShot;
    }
    get isImmersion() {
        return store.isImmersion;
    }
    get minuteTimer() {
        return store.minuteTimer;
    }
    mounted() {
        this.setHeadLogo();
        this.setWeather();
        this.setDashboard();
    }
    onChangePath() {
        this.setRefreshTask();
    }
    onChangeMinuteTimer() {
        this.timeCount++;
        if (!(this.timeCount % 10)) {
            // 10分钟更新一次
            this.timeCount = 0;
            if (store.mapData.weatherType === 'REAL') {
                this.setWeather();
            }
        }
        if (this.refreshTime && moment().format('HH:mm') === this.refreshTime) {
            // 大屏刷新页面
            location.reload();
        }
    }
    onMouseEnter() {
        this.immersionButtonStatus = 1;
    }
    onMouseLeave() {
        this.immersionButtonStatus = 0;
    }
    setHeadLogo() {
        try {
            this.defaultLogoUrl = LoginModule?.logoConfig?.defaultLogoUrl;
            this.defaultLogoName = LoginModule?.logoConfig?.systemName;
        }
        catch (e) { }
    }
    async setDashboard() {
        const { MAP: mapData = [] } = (await dashboardConfig());
        console.log('mapData:', mapData);
        this.mapItems = mapData.map((item) => {
            const curr = MAP_ITEMS.find((map) => map.cardId === item.cardId);
            return {
                ...item,
                name: item.cardName,
                path: curr?.path,
                snapShot: curr?.snapShot,
            };
        });
        this.setRefreshTask();
    }
    startImmersion() {
        store.updateIsImmersion(true);
        store.updateIsShow(false);
    }
    setRefreshTask() {
        if (!this.mapItems.length)
            return;
        const choosedItem = this.mapItems.find((item) => item.path === this.path);
        this.reloadTimer && clearInterval(this.reloadTimer);
        if (choosedItem?.refreshTime) {
            this.refreshTime = choosedItem.refreshTime;
        }
    }
    async setWeather() {
        const dateTime = moment().format('YYYY-MM-DD HH:mm:ss');
        const { weatherText, celsius } = (await fetchWeather({ dateTime }));
        this.celsius = celsius;
        this.weather = weatherText;
        store.updateSysWeather(this.weather || 'sunny');
    }
    handleChange(path) {
        if (path === this.path)
            return;
        store.updateIsShow(false);
        store.updateSingleMapData({
            key: 'operationMode',
            value: 'sandTable',
        });
        store.updateTravelInitialPosition('');
        this.snapDateChange('');
        this.$router.push({ path });
    }
    beforeDestroy() {
        this.reloadTimer && clearInterval(this.reloadTimer);
    }
};
__decorate([
    Emit('snapDateChange')
], default_1.prototype, "snapDateChange", null);
__decorate([
    Watch('path')
], default_1.prototype, "onChangePath", null);
__decorate([
    Watch('minuteTimer', { immediate: true })
], default_1.prototype, "onChangeMinuteTimer", null);
default_1 = __decorate([
    Component({
        name: 'ScreenHead',
        components: { Clock, SnapShot, ImmersionMode },
        i18n: {
            messages: {
                'en-us': {
                    CAM: 'Crowd Insight(CAM)',
                    CL: 'Crowd Insight(CL)',
                    VA: 'Crowd Insight(VA)',
                    QUEUE: 'Queue Insight',
                    ALARM: 'Alert Map',
                    PARKING: 'Parking Insight',
                    IMMERSION: 'Immersion',
                },
                zh: {
                    CAM: '人群洞察(CAM)',
                    CL: '人群洞察(CL)',
                    VA: '人群计数（VA）',
                    QUEUE: '排队洞察',
                    ALARM: '告警地图',
                    PARKING: '停车洞察',
                    IMMERSION: '沉浸模式',
                },
            },
        },
    })
    /**
     * screen-head
     * 大屏顶部栏 组件引入注解
     * 引入方式：<screen-head @snapDateChange="snapDateChange" />
     *
     * 支持的事件如下：
     * snapDateChange 快照时间选择的事件
     */
], default_1);
export default default_1;
